import { createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0ce75883")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: { 'chart-outer': _ctx.hasError }
  }, [
    _createVNode("canvas", {
      id: _ctx.index + 'chart',
      class: "canvas-size"
    }, null, 8, ["id"]),
    _withDirectives(_createVNode("p", null, _toDisplayString(_ctx.$t("default.alert.no_data")), 513), [
      [_vShow, _ctx.hasError]
    ])
  ], 2))
})